import { render } from "./component-prolongation-date.vue?vue&type=template&id=37ec6a92"
import script from "./component-prolongation-date.vue?vue&type=script&setup=true&lang=js"
export * from "./component-prolongation-date.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-prolongation-date.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37ec6a92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37ec6a92', __exports__)) {
    api.reload('37ec6a92', __exports__)
  }
  
  module.hot.accept("./component-prolongation-date.vue?vue&type=template&id=37ec6a92", () => {
    api.rerender('37ec6a92', render)
  })

}


export default __exports__